import templateUrl from "./image-cropper-modal.html"
import './image-cropper-modal.component.less'

export const ImageCropperModalComponent = {
    templateUrl,
    controller: ImageCropperModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};

export function ImageCropperModalController($q) {
    'ngInject'
    const vm = this;
    vm.resolve;
    vm.close;
    vm.dismiss;
    vm.$onInit = onInit;
    vm.onCropImage = onCropImage;
    vm.onClose = onClose;
    function onInit() {
        vm.currentImage = vm.resolve.dataUrl;
        vm.areaType = vm.resolve.areaType;
        vm.cropper = {
            cropHeight: vm.resolve.cropHeight,
            cropWidth: vm.resolve.cropWidth,
            resultHeight: vm.resolve.resultHeight,
            resultWidth: vm.resolve.resultWidth
        }
    }

    function onCropImage() {
        vm.close({ $value: vm.resultImage });
    }

    function onClose() {
        vm.close({ $value: null });
    }
}

export const ImageCropperModal = {
    component: "apexImageCropperModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
};
